import React, { useState, Fragment } from "react";
import { Popover } from "@material-ui/core";
import { Avatar } from "../../../Components/Avatar/Avatar";
import "./Network.css";
import PhoneIcon from "@material-ui/icons/Phone";

const CallButton = () => {
  const [openPopup, setOpenPopup] = useState(null);

  return (
    <Fragment>
      <div className="callBtn">
        <Avatar
          className="avtarBtn"
          style={{ backgroundColor: "blue" }}
          onClick={(e: any) => setOpenPopup(e.currentTarget)}
        >
          <PhoneIcon
            className="avtarBtn"
            onClick={(e: any) => setOpenPopup(e.currentTarget)}
          />
        </Avatar>
      </div>
      <Popover
        open={Boolean(openPopup)}
        anchorEl={openPopup}
        onClose={() => setOpenPopup(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div style={{ marginTop: "10px", marginBottom: "-10px" }}>
          <p>
            <a
              href="tel:7575857777"
              style={{ marginLeft: "10px", marginRight: "10px" }}
            >
              {" "}
              <PhoneIcon style={{ verticalAlign: "sub", fontSize: "20px" }} />
              7575857777
            </a>
          </p>
          <p>
            <a
              href="tel:7227056569"
              style={{ marginLeft: "10px", marginRight: "10px" }}
            >
              {" "}
              <PhoneIcon style={{ verticalAlign: "sub", fontSize: "20px" }} />
              7227056569
            </a>
          </p>
        </div>
      </Popover>
    </Fragment>
  );
};

export default CallButton;
